import { render, staticRenderFns } from "./accruedChange.vue?vue&type=template&id=cbc6d4b6&scoped=true"
import script from "./accruedChange.vue?vue&type=script&lang=js"
export * from "./accruedChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc6d4b6",
  null
  
)

export default component.exports